<template>
  <div>
    <h1 class="text-success">Formulario Clasificación por Tamizaje en Niño/as</h1>
    <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará el tipo de tamizaje para niños/as.
    </div>
    <div class="mt-4">
      <button @click="showCreateForm" class="btn btn-primary">Agregar Tipo de Tamizaje</button>
    </div>

    <!-- Lista de TamizajeNiño en una tabla -->
    <div class="table-responsive mt-3">
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Tipo de tamizaje</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tamizajeNiño in tamizajeNiñoList" :key="tamizajeNiño._id">
            <td>{{ tamizajeNiño.nombre }}</td>
            <td>
              <div class="btn-group" role="group">
                <button @click="editTamizajeNiño(tamizajeNiño)" class="btn btn-warning btn-sm">Editar</button>
                <button @click="deleteTamizajeNiño(tamizajeNiño._id)" class="btn btn-danger btn-sm">Eliminar</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Formulario de creación/editar -->
    <div v-if="showForm" class="mt-4">
      <h2 class="h4">{{ isEditing ? 'Editar TamizajeNiño' : 'Agregar TamizajeNiño' }}</h2>
      <form @submit.prevent="isEditing ? updateTamizajeNiño() : createTamizajeNiño()" class="form-inline">
        <div class="form-group mr-2">
          <label for="nombre" class="mr-2">Nombre</label>
          <input v-model="formData.nombre" type="text" id="nombre" required class="form-control form-control-lg" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
          <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      tamizajeNiñoList: [],
      showForm: false,
      formData: {
        nombre: '',
      },
      isEditing: false,
      editingTamizajeNiñoId: null,
    };
  },
  methods: {
    async fetchTamizajeNiño() {
      try {
        const response = await axios.get(`${BASE_URL}/api/tamizajeninoclasificacion`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.tamizajeNiñoList = response.data;
      } catch (error) {
        console.error('Error al obtener TamizajeNiño:', error);
      }
    },
    showCreateForm() {
      this.showForm = true;
      this.isEditing = false;
      this.formData = {
        nombre: '',
      };
    },
    async createTamizajeNiño() {
      try {
        await axios.post(`${BASE_URL}/api/tamizajeninoclasificacion`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Guardada!',
          text: 'La información de TamizajeNiño ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchTamizajeNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al guardar la información de TamizajeNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    clearFields() {
      this.formData = {
        nombre: '',
      };
    },
    deleteTamizajeNiño(id) {
      swal({
        title: '¿Estás seguro?',
        text: 'Una vez eliminado, no podrás recuperar este registro.',
        icon: 'warning',
        buttons: ['Cancelar', 'Eliminar'],
        dangerMode: true,
      })
      .then((confirmation) => {
        if (confirmation) {
          this.performTamizajeNiñoDeletion(id);
        }
      });
    },
    async performTamizajeNiñoDeletion(id) {
      try {
        await axios.delete(`${BASE_URL}/api/tamizajeninoclasificacion/${id}`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Eliminada!',
          text: 'La información de TamizajeNiño ha sido eliminada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.fetchTamizajeNiño();
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Hubo un error al eliminar la información de TamizajeNiño.',
          icon: 'error',
          button: 'OK',
        });
      }
    },
    editTamizajeNiño(tamizajeNiño) {
      this.isEditing = true;
      this.editingTamizajeNiñoId = tamizajeNiño._id;
      this.formData.nombre = tamizajeNiño.nombre;
      this.showForm = true;
    },
    async updateTamizajeNiño() {
      try {
        await axios.put(`${BASE_URL}/api/tamizajeninoclasificacion/${this.editingTamizajeNiñoId}`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Actualizada!',
          text: 'La información de TamizajeNiño ha sido actualizada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchTamizajeNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al editar la información de TamizajeNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    cancelEdit() {
      this.showForm = false;
      this.isEditing = false;
      this.clearFields();
    },
  },
  mounted() {
    this.fetchTamizajeNiño();
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
